import { observer } from 'mobx-react';
import InviteParticipantStore from '../../../../../Store';
import { SelectParticipantsState } from '../../../../../Types';
import SelectedUsers from '../../../../../../../../SelectedUsers';
import NextButton from './NextButton';
import LicenseMessage from '../../../../../../../../LicenseMessage';

export interface Props {
  store: InviteParticipantStore;
  state: SelectParticipantsState;
}

function Participants({ store, state }: Props) {
  return (
    <>
      <div className="max-h-60 h-60 text-sm overflow-y-auto">
        <SelectedUsers
          newGroupsAndParticipants={state.newGroupsAndParticipants}
          removeGroup={store.removeGroup}
          removeParticipant={store.removeParticipant}
        />
      </div>
      <LicenseMessage
        activationsRemaining={state.activationsRemaining}
        title={state.publicName}
        newLicenseAllocations={state.newLicenseAllocations}
        allocatedLicenses={state.allocatedLicenses}
      />
      <NextButton
        store={store}
        activationsRemaining={state.activationsRemaining}
        shareUrl={state.shareUrl}
      />
    </>
  );
}

export default observer(Participants);
